import dayjs from 'dayjs'

export function getDisplayTime(timeUTC: Date): string | null {
  if (!dayjs(timeUTC).isValid()) {
    return null
  }

  return dayjs(timeUTC).format('ddd, D MMM YYYY, H:mm')
}
